<template>
  <div id="japanHardView">
    <div class="contents">
      <div id="reset_btn_view">
        <div :class="{ activ_btn: isActive }" id="reset_btn" @click="resetGame">リセット</div>
        <div id="close_btn">
          <router-link to="/japan" class="close_link">
            <p>
              <font-awesome-icon icon="times" />
            </p>
          </router-link>
        </div>
      </div>

      <div id="title_view">
        <h1>{{ title }}</h1>
      </div>

      <div id="roulette_views">
        <div id="item_view">
          <h2>{{ item_title1_src }}</h2>
          <h3>
            {{ item_title2_src }}
            <span>{{ item_unit1 }}</span>
            {{ item_title3_src }}
            <span>{{ item_unit2 }}</span>
          </h3>
          <div id="answer_count_label" v-show="answer_btn_show">
            {{ answer_count }}
            <p>県</p>
          </div>
        </div>
      </div>

      <div id="ctrl_btns">
        <div class="activ_btn" id="answer_btn" v-show="answer_btn_show" @click="showAnswer">正解を表示</div>
        <div :class="{ activ_btn: isActive }" id="start_btn" @click="playGame">{{ start_btn_label }}</div>
      </div>

      <!-- 正解 -->
      <vodal class="vodal_view my-dialog" measure="px" :show="answer_view_show" :animation="animation" :width="280" :height="answer_view_height" :duration="301" @hide="answer_view_show = false">
        <div class="vodal_view">
          <div class="vodal_header">正解は…</div>
          <ul id="example-1">
            <li v-for="item in answerItems" :key="item.id" id="restAnswer">{{ item.message }}</li>
            <li v-for="item in answerItemsS" :key="item.id" id="selectedAnswer">
              {{ item.message }}
              <img :src="sumi_src" width="30px" alt>
            </li>
            <li>
              <div @click="showChart" id="chart_btn">
                <font-awesome-icon icon="align-left" />グラフをみてみよう
              </div>
            </li>
          </ul>
          <div class="vodal_footer_s">
            <div @click="nextGame">Next !</div>
          </div>
        </div>
      </vodal>

      <!-- 正解のグラフ -->
      <vodal class="vodal_view my-dialog" measure="px" :show="chart_view_show" :animation="animation" :width="chart_width" :height="chart_height" :duration="301" @hide="chart_view_show = false">
        <div class="vodal_view_chart">
          <div class="vodal_header">
            <p>
              <font-awesome-icon icon="align-left" style="color: #629931 margin-right: 6px" />
              {{ item_title1_src }}{{ item_units }}
              <br>
              {{ item_title2_src }}{{ item_unit1 }}{{ item_title3_src }}{{ item_unit2 }}
            </p>
          </div>
          <div class="vodal_chart_content">
            <ChartView />
          </div>
          <div class="vodal_footer">
            <div @click="chart_view_show = false">Close</div>
          </div>
        </div>
      </vodal>

      <!-- 終了 -->
      <vodal measure="px" :show="finish_alert_show" :animation="animation" :width="300" :height="240" :duration="600" class="my-dialog" @hide="finish_alert_show = false">
        <div class="vodal_view">
          <div class="vodal_mark" style="font-size: 30px color: #B78333">
            <font-awesome-icon icon="trophy" />
          </div>
          <div class="vodal_header">ゲーム終了！</div>
          <div class="vodal_content">
            リセットボタンを押して
            <br>最初から始めよう！
          </div>
          <div class="vodal_footer">
            <div @click="finish_alert_show = false">OK</div>
          </div>
        </div>
      </vodal>

      <!-- リセット -->
      <vodal measure="px" :show="reset_alert_show" :animation="animation" :width="300" :height="240" :duration="300" class="my-dialog" @hide="reset_alert_show = false">
        <div class="vodal_view">
          <div class="vodal_header">
            <font-awesome-icon icon="redo-alt" />
            <p>リセット</p>
          </div>
          <div class="vodal_content">
            ゲームをリセットします。
            <br>よろしいですか？
          </div>
          <div class="vodal_footer">
            <div @click="reset_alert_show = false">Cancel</div>
            <div @click="resetGameB">OK</div>
          </div>
        </div>
      </vodal>
    </div>
  </div>
</template>

<script>
import Vodal from "vodal"
import ChartView from "./ChartView.vue"
import soundMixin from '../libs/soundMixin.js'
import gameHardMixin from '../libs/gameHardMixin.js'
/**
 * 日本がわかるルーレット 上級編
 * 
 * @vue-data {String} [title='日本がわかるルーレット 上級編'] ルーレットのタイトル
 * @vue-data {String} [item_title1_src='お題'] お題の統計情報のカテゴリー
 * @vue-data {String} [item_title2_src=''] お題の統計情報の最小値
 * @vue-data {String} [item_title3_src=''] お題の統計情報の最大値
 * @vue-data {String} [item_unit1=''] 最小値の単位
 * @vue-data {String} [item_unit2=''] 最大値の単位
 * @vue-data {String} [item_units=''] お題の単位（棒グラフのタイトルに表示）
 * @vue-data {String} [start_btn_label='スタート'] スタートボタンのラベルテキスト
 * @vue-data {Object} [questionTimer1=null] お題ルーレットのタイマー
 * @vue-data {Int} [stopInterval=4000] ルーレットの表示間隔（4秒）
 * @vue-data {Int} [currentQuestionIndex=0] お題のインデックス
 * @vue-data {Array} [restDataID=[]] 残りのカードのIDの配列
 * @vue-data {Array} [selectedDataID=[]] 表示済みのカードのIDの配列
 * @vue-data {Array} [currentQuestionAnswers:[]] 残りのカードのうち、お題に該当するカードのIDの配列
 * @vue-data {Boolean} [answer_btn_show=false] 「正解を表示」ボタンの表示フラグ
 * @vue-data {Boolean} [answer_view_show=false] 正解ポップアップの表示フラグ
 * @vue-data {Int} [answer_view_height=24] 正解ポップアップ高さ
 * @vue-data {String} [animation=''] ポップアップのアニメーションタイプ（flip, rotate, slideDown, slideUp)
 * @vue-data {Array} [answerItems=[]] 正解のli要素の配列
 * @vue-data {Array} [answerItemsS=[]] 正解のli要素の配列（表示済みのタイプ）
 * @vue-data {Boolean} [chart_view_show=false] グラフポップアップの表示フラグ
 * @vue-data {Boolean} [finish_alert_show=false] ゲーム終了ポップアップの表示フラグ
 * @vue-data {Boolean} [reset_alert_show=false] リセットポップアップの表示フラグ
 * @vue-data {Int} [answer_count=3] 残りのカードのうち、お題に該当するカードの枚数
 * @vue-data {Object} [sumi_src] 「済」イメージ
 * @vue-data {Object} [rouletteSounds=null] ルーレット音のAudioオブジェクト
 * @vue-data {Object} [rouletteStopSounds=null] ルーレット停止音のAudioオブジェクト
 * @vue-data {Object} [popupSounds=null] ポップアップ表示音のAudioオブジェクト
  * @vue-data {Boolean} [isActive=true] ボタンイベントのアクティブフラグ（ルーレット作動中に無効にする）
 * @vue-computed {Array} data 日本県データ
 * @vue-computed {Array} qdata 日本質問データ
 * @vue-computed {Boolean} soundsMute 効果音・BGMのミュートフラグ（true, false）
 * @vue-computed {Int} chart_width グラフポップアップの幅
 * @vue-computed {Int} chart_height グラフポップアップの高さ
 * @ue-computed {Object} snd サウンドオブジェクト
 */
export default {
  name: "japanHard",

  components: {
    Vodal,
    ChartView
  },

  mixins: [
    soundMixin,
    gameHardMixin
  ],

  data () {
    return {
      title: "日本がわかるルーレット 上級編",
      item_title1_src: "お題",
      item_title2_src: "",
      item_title3_src: "",
      item_unit1: "",
      item_unit2: "",
      item_units: "",
      start_btn_label: "スタート",
      questionTimer1: null,
      stopInterval: 4000,
      currentQuestionIndex: 0,
      restDataID: [],
      selectedDataID: [],
      currentQuestionAnswers: [],
      answer_btn_show: false,
      answer_view_show: false,
      answer_view_height: 24,
      animation: "",
      answerItems: [],
      answerItemsS: [],
      chart_view_show: false,
      finish_alert_show: false,
      reset_alert_show: false,
      answer_count: 3,
      sumi_src: require("../assets/sumi.png"),
      rouletteSounds: null,
      rouletteStopSounds: null,
      popupSounds: null,
      isActive: true
    }
  },

  created () {
    this.shuffleQuestionData()
    this.resetRestDataIndex()
  },

  mounted () {
    // console.log(this.$options.name)
    this.$store.dispatch("setCurrentGame", { gameName: this.$options.name }) // コンポーネント名保存
    this.$store.dispatch("setQuestionIndex", { idx: -1 }) // 保存
  },

  computed: {
    data () {
      return this.$store.getters.japanData
    },
    qdata () {
      return this.$store.getters.questionDataJ
    },
    soundsMute () {
      return this.$store.getters.soundsMute
    },
    chart_width () {
      let vw = this.$store.getters.currentViewWidth
      if (vw >= 800) {
        return 720
      }
      return this.$store.getters.currentViewWidth - 80
    },
    chart_height () {
      let vh = this.$store.getters.currentViewHeight
      if (vh >= 750) {
        return 600
      }
      return vh - 100
    },
    snd () {
      return this.$store.getters.snd
    }
  },

  watch: {
    soundsMute () {
      if (this.soundsMute) {
        this.stopRouletteSound()
      } else {
        if (this.timerIsRunnig()) {
          this.playRouletteSound()
        }
      }
    }
  }
}
</script>

<style lang="sass" src='../assets/common_style.sass'></style>
<style lang="sass" src='../assets/hard_common.sass'></style>
<style lang="sass" scoped>
#item_view
  border: 8px solid #88CFFF
  h2
    color:  #88CFFF

#answer_count_label
  background: #88CFFF

#start_btn
  background-color: #FDD863
  box-shadow: 0 3px 0 #E8BD38

#answer_btn
  background-color: #FF6D8D
  box-shadow: 0 3px 0 #DD3E60

#chart_btn
  color: #629931
</style>
